
export const driversSummary = [
    {
        text: <span><span className={'green-color'}>30k</span>/28k</span>,
        name: 'Kms Travelled',
        color: 'light-color'
    },
    {
        text: <span><span className={'green-color'}>43k</span>/40k</span>,
        name: 'No of Trips',
        color: 'light-color'
    },
    {
        text: '649',
        name: 'FCW',
        color: 'green-color'
    },
    {
        text: '189',
        name: 'PCW',
        color: 'red-color'
    },
    {
        text: '1.6k',
        name: 'LDW',
        color: 'green-color'
    },
    {
        text: 738,
        name: 'HA',
        color: 'red-color'
    },
    {
        text: 699,
        name: 'HB',
        color: 'red-color'
    },
    {
        text: 451,
        name: 'DIS',
        color: 'green-color'
    },
    {
        text: '2k',
        name: 'HMW',
        color: 'red-color'
    },
    {
        text: 201,
        name: 'DRW',
        color: 'green-color'
    },
];

export const driverSummary = [
    {
        text: <span><span className={'green-color'}>30k</span>/28k</span>,
        name: 'Kms Travelled',
        color: 'light-color'
    },
    {
        text: <span><span className={'green-color'}>43k</span>/40k</span>,
        name: 'No of Trips',
        color: 'light-color'
    },
    {
        text: '649',
        name: 'FCW',
        color: 'green-color'
    },
    {
        text: '189',
        name: 'PCW',
        color: 'red-color'
    },
    {
        text: '1.6k',
        name: 'LDW',
        color: 'green-color'
    },
    {
        text: 738,
        name: 'HA',
        color: 'red-color'
    },
    {
        text: 699,
        name: 'HB',
        color: 'red-color'
    },
    {
        text: 451,
        name: 'DIS',
        color: 'green-color'
    },
    {
        text: '2k',
        name: 'HMW',
        color: 'red-color'
    },
    {
        text: 201,
        name: 'DRW',
        color: 'green-color'
    },
];

export const driverList = [
    {
        img: 'user-1',
        name: 'Babu K',
        rating:  4.8,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 24609,
        action: '',
    },
    {
        img: 'user-2',
        name: 'Ramesh J',
        rating:  4.6,
        alertness: 'Good',
        alerts: 1,
        criticalAlerts: 2,
        id: 68858,
        action: 'Coaching',
    },
    {
        img: 'user-3',
        name: 'Sundarajan',
        rating:  4.7,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 94038,
        action: '',
    },
    {
        img: 'user-4',
        name: 'Antony ',
        rating:  4.5,
        alertness: 'Ok',
        alerts: 0,
        criticalAlerts: 3,
        id: 22010,
        action: '',
    },
    {
        img: 'user-1',
        name: 'Babu K',
        rating:  4.8,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 24601,
        action: '',
    },
    {
        img: 'user-2',
        name: 'Ramesh J',
        rating:  4.6,
        alertness: 'Good',
        alerts: 1,
        criticalAlerts: 2,
        id: 68853,
        action: 'Coaching',
    },
    {
        img: 'user-3',
        name: 'Sundarajan',
        rating:  4.7,
        alertness: 'Good',
        alerts: 0,
        criticalAlerts: 4,
        id: 94032,
        action: '',
    },
    {
        img: 'user-4',
        name: 'Antony ',
        rating:  4.5,
        alertness: 'Ok',
        alerts: 0,
        criticalAlerts: 3,
        id: 22016,
        action: '',
    }
]
